"use strict";
/**
 * Canonical price arithmetic for orderbook prices.
 *
 * Venue feeds quote prices as decimal dollars in [0, 1] with up to 4 decimal
 * places (tick can be as small as 0.0001). The canonical internal unit is
 * integer basis points (bps, 1 bp = $0.0001, range 0-10000): all conversion,
 * inversion, and bucketing goes through bps so float representation error
 * (e.g. 0.5125 * 100 === 51.24999999999999) can never leak into map keys or
 * derived prices.
 *
 * Kalshi orderbook maps are keyed by cent strings ("51", "51.25"). Every
 * producer of those keys MUST derive them via dollarStrToCentKey /
 * invertCentKey, or snapshot and delta updates at the same price will land on
 * different keys.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.dollarsToBps = dollarsToBps;
exports.bpsToDollarString = bpsToDollarString;
exports.dollarStrToCentKey = dollarStrToCentKey;
exports.centKeyToBps = centKeyToBps;
exports.invertCentKey = invertCentKey;
exports.invertBps = invertBps;
exports.centBucketUpBps = centBucketUpBps;
exports.centBucketDownBps = centBucketDownBps;
/** Convert a decimal-dollar price (string or number) to integer basis points. */
function dollarsToBps(dollars) {
    return Math.round(Number(dollars) * 10000);
}
/** Format basis points as a 4-decimal dollar string, e.g. 5125 → "0.5125". */
function bpsToDollarString(bps) {
    return (bps / 10000).toFixed(4);
}
/**
 * Canonical cent-string key for a decimal-dollar price.
 * "0.51" → "51", "0.5125" → "51.25" (integer division keeps whole cents
 * free of a trailing ".00" so existing 2dp keys are byte-identical).
 */
function dollarStrToCentKey(dollars) {
    return (dollarsToBps(dollars) / 100).toString();
}
/** Parse a canonical cent-string key back to basis points. */
function centKeyToBps(centKey) {
    return Math.round(parseFloat(centKey) * 100);
}
/** Invert a cent-string key across $1: "51.25" → "48.75". */
function invertCentKey(centKey) {
    return ((10000 - centKeyToBps(centKey)) / 100).toString();
}
/** Invert basis points across $1 (10000 bps). */
function invertBps(bps) {
    return 10000 - bps;
}
/** Round bps up to the next whole cent (identity on exact cents). */
function centBucketUpBps(bps) {
    return Math.ceil(bps / 100) * 100;
}
/** Round bps down to the previous whole cent (identity on exact cents). */
function centBucketDownBps(bps) {
    return Math.floor(bps / 100) * 100;
}
